import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder the product photo tiles on the admin product form.
// On drop, PATCHes the new order to the urlValue endpoint, which rewrites
// each ProductPhoto's sort_order. Replaces the former jQuery UI sortable.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 150,
      ghostClass: "my-placeholder",
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  save() {
    const body = new URLSearchParams()
    this.element.querySelectorAll('[id^="product_photo_"]').forEach((tile) => {
      const id = tile.id.replace("product_photo_", "")
      if (id) body.append("product_photo[]", id)
    })

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-CSRF-Token": csrfToken
      },
      body: body.toString()
    })
      .then((response) => {
        if (!response.ok) throw new Error("Save failed")
      })
      .catch(() => {
        alert("Sorry, we couldn't save your changes.")
      })
  }
}
